import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyLetters]'
})
export class OnlyLettersDirective {

  constructor(@Optional() private formControl: NgControl) { }
  @HostListener('input', ['$event']) onInput(event: any) {
    if (this.formControl) {
      if(this.formControl.control!.value){
        this.formControl.control!.patchValue(this.formControl.control!.value.replaceAll(/[^a-zA-ZñÑáéíóúÁÉÍÓÚ ]/gi, ''));
      }
    }
  }
}
